<template>
  <material-card
    :title="`${ $t('Sensor alarms') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md3>
            <v-select
              v-model="filters.number"
              :items="sensors"
              :disabled="filters.all || progessBar.loading"
              :label="`${ $t('Sensor') }`"
              item-text="description"
              item-value="sensorNumber"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item.sensorNumber"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item.sensorNumber }}</v-avatar>
                  {{ data.item.sensorName }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs12
            md2>
            <v-switch
              v-model="filters.all"
              :disabled="progessBar.loading"
              :label="filters.type === 0 ? `${ $t('All tanks') }` : `${ $t('All sensors') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(-7)"
              :date-label="getDateLabel('From')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="2"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(0)"
              :date-label="getDateLabel('To')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || progessBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Load') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progessBar.loading"
              :indeterminate="false"
              :max-value="progessBar.maxValue"
              :value="progessBar.currentValue" />
            <span>{{ itemCountLabel }}</span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                  class="text-xs-left">
                  <td class="text-xs-center">{{ Maglink.GetCustomDateTime(item.measuredOn, systemSettings.dateFormat) }}</td>
                  <td class="text-xs-left">{{ getSensorTypeDescription(item.sensorType) }}</td>
                  <td class="text-xs-left">{{ getLocation(item) }}</td>
                  <td class="text-xs-center">{{ item.sensorNumber }}</td>
                  <td class="text-xs-left">{{ item.sensorName }}</td>
                  <td class="text-xs-center">{{ getAlarmDescription(item.sensorStatus) }}</td>
                  <td class="text-xs-center">{{ Maglink.GetAckDescription(item.ackStatus) }}</td>
                  <td>
                    <img
                      :src="Maglink.GetImageAlarm(item.ackStatus)"
                      width="15px">
                  </td>
                  <!--
                  <td class="text-xs-right">{{ getValue(item.sensorType, item.productLevel) }}</td>
                  <td class="text-xs-right">{{ getValue(item.sensorType, item.waterLevel) }}</td>
                  -->
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      isDate: [ v => true ]
    },
    progessBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    itemCountLabel: '',
    siteInfo: {},
    headers: [],
    dataSource: [],
    sensors: [],
    sensorTypes: [],
    locations: [],
    filters: {
      all: false,
      number: 1,
      type: 1,
      fromDay: '',
      toDay: ''
    },
    enumAssociationType: {
      tank: 0,
      sensor: 1,
      sump: 2, // dispenser, sump
      site: 3 // site, well
    }

  }),
  mounted () {
    this.sensorTypes = this.Maglink.SensorTypesBasic()
    this.sensorTypes = this.sensorTypes.concat(this.Maglink.SensorTypesPlus())

    var currentDate = new Date()
    this.filters.toDay = currentDate.toISOString().substr(0, 10)

    currentDate.setDate(currentDate.getDate() - 7)
    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    // let levelUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    // let volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

    this.headers = [
      { sortable: false, text: this.$t('Time'), align: 'center' },
      { sortable: false, text: this.$t('Type'), align: 'center' },
      { sortable: false, text: this.$t('Location'), align: 'left' },
      { sortable: false, text: this.$t('Number'), align: 'center' },
      { sortable: false, text: this.$t('Name'), align: 'left' },
      { sortable: false, text: this.$t('Alarm'), align: 'center' },
      { sortable: false, text: this.$t('Status'), align: 'center' },
      { sortable: false, text: '' }
    ]

    this.getSiteInfo()
    this.getSensors()
  },
  methods: {
    applyFilter () {
      if (!this.onCheckDates()) return
      this.getDataSource()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getSiteInfo () {
      this.Maglink.GetSettings('SiteInfo')
        .then(response => {
          this.siteInfo = { ...this.siteInfo, ...response.data }
          this.getLocations()
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getLocations () {
      let totalTanks = this.siteInfo.tanksNumber
      let list = []
      for (let index = 1; index <= totalTanks; index++) {
        list.push({ index: list.length, id: index, desc: this.$t('Tank {0}', [index]), associationType: this.enumAssociationType.tank })
      }
      for (let index = 1; index <= totalTanks; index++) {
        list.push({ index: list.length, id: index, desc: this.$t('Sump {0}', [index]), associationType: this.enumAssociationType.sump })
      }
      list.push({ index: list.length, id: 1, desc: this.$t('Site/well'), associationType: this.enumAssociationType.site })
      this.locations = list
    },
    getValue (sensorType, value) {
      if (sensorType > 0) return value

      return '--'
    },
    getLocation (item) {
      let totalTanks = this.siteInfo.tanksNumber
      let index = 0

      if (item.associationType === this.enumAssociationType.tank) {
        index = item.associationAddress - 1
      } else if (item.associationType === this.enumAssociationType.sump) {
        index = item.associationAddress + totalTanks - 1
      } else if (item.associationType === this.enumAssociationType.site) {
        index = this.locations.length - 1
      }
      return this.locations[index].desc
    },
    getSensorTypeDescription (sensorType) {
      return this.sensorTypes[sensorType].desc
    },
    getAlarmDescription (code) {
      return this.Maglink.GetStatusInfo(code).statusDesc.toUpperCase()
    },
    getSensors () {
      this.sensors = []

      this.Maglink.GetSensors()
        .then(response => {
          // filter only on/off sensor
          this.sensors = response.data
          this.sensors.sort((a, b) => ((a.sensorType.toString() + a.sensorNumber.toString()) > (b.sensorType.toString() + b.sensorNumber.toString())) ? 1 : -1)

          for (let index = 0; index < this.sensors.length; index++) {
            let sensor = this.sensors[index]
            sensor.description = this.getSensorTypeDescription(sensor.sensorType) + ': ' + sensor.sensorNumber + '-' + sensor.sensorName
          }
          // read sensor alarm
          this.applyFilter()
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getDataSource () {
      this.progessBar.loading = true
      this.dataSource = []

      this.Maglink.GetReportSensorAlarms(this.filters)
        .then(response => {
          this.progessBar.maxValue = response.data.length

          for (var i = 0; i < response.data.length; i++) {
            this.progessBar.currentValue = i
            this.dataSource.push(this.Maglink.ToDisplay(response.data[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
          }
          this.progessBar.loading = false
          this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
        })
        .catch(error => {
          this.progessBar.loading = false
          this.snack('error', error.message)
        })
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.$t(this.systemSettings.dateFormat) + ')'
    },
    onCheckDates () {
      // no check if one date is missing
      if (this.filters.fromDay === undefined) return true
      if (this.filters.toDay === undefined) return true

      if (this.filters.fromDay > this.filters.toDay) {
        this.isValidationOk = false
        this.rules.isDate = [this.$t('Wrong date value')]
      } else {
        this.rules.isDate = [ v => true ]
        this.isValidationOk = true
        this.$refs.form.resetValidation()
      }

      return this.isValidationOk
    },
    onGetDate (componentKey, day) {
      if (componentKey === 1) {
        this.filters.fromDay = day
      } else {
        this.filters.toDay = day
      }

      this.onCheckDates()
    },
    snack (color, message) {
      message = this.$t('Sensor alarms') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>

<style scoped>
.scroller {
  table-layout: fixed;
  height: 300px;
  max-height: 300px;
  overflow: auto;
}
.list {
    background-color: #ffffff;
    -webkit-overflow-scrolling: touch;
}
.column {
  width: 20%;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  color: gray;
}
.columnbig {
  width: 30%;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  color: gray;
}
</style>
